// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3PRqJ","col":"styles_col__1kgHC"};